import { DetailsList, IColumn, SelectionMode, DetailsListLayoutMode, Text } from '@fluentui/react'
import { TokenUsage } from '../../api/models'
import PerformancePanel from './PerformancePanel'
import { formatCost, formatTokenCount } from './performanceFormat'

export type TokenBreakdownRow = TokenUsage & {
  model?: string
}

type TokenBreakdownTableProps = {
  title: string
  rows: TokenBreakdownRow[]
  currency: string | null
  showModel?: boolean
}

const numericColumn = (key: string, name: string, render: (row: TokenBreakdownRow) => string): IColumn => ({
  key,
  name,
  minWidth: 70,
  maxWidth: 110,
  onRender: (row: TokenBreakdownRow) => <Text styles={{ root: { fontVariantNumeric: 'tabular-nums' } }}>{render(row)}</Text>,
})

const buildColumns = (currency: string | null, showModel: boolean): IColumn[] => [
  { key: 'label', name: 'Label', fieldName: 'label', minWidth: 100, isMultiline: true },
  ...(showModel ? [{ key: 'model', name: 'Model', fieldName: 'model', minWidth: 90, isMultiline: true }] : []),
  numericColumn('input', 'Input', (row) => formatTokenCount(row.input_tokens)),
  numericColumn('output', 'Output', (row) => formatTokenCount(row.output_tokens)),
  numericColumn('cost', 'Est. cost', (row) => formatCost(row.cost, currency)),
]

const TokenBreakdownTable = ({ title, rows, currency, showModel = false }: TokenBreakdownTableProps) => (
  <PerformancePanel
    title={title}
    isEmpty={rows.length === 0}
    emptyMessage="No token usage recorded for this period."
    headingLevel="h3"
    minWidth={320}
  >
    <DetailsList
      items={rows}
      columns={buildColumns(currency, showModel)}
      selectionMode={SelectionMode.none}
      layoutMode={DetailsListLayoutMode.justified}
      compact
      ariaLabelForGrid={`Token spend ${title.toLowerCase()}`}
      onShouldVirtualize={() => false}
    />
  </PerformancePanel>
)

export default TokenBreakdownTable
